import { useEffect, useState } from "react";
const AboutUs = () =>{

    return(<>
    
    {/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
     <img src="/assets/img/banner/about-banner.jpg" alt="MeriPustak-About"/>
       
    </div>

    {/* <!-- About Section Start --> */}
    <section className="about-section fix section-padding">
        <div className="container">
            <div className="about-wrapper">
			
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                        <div className="about-image">
                            <img src="assets/img/static-img/about.jpg" alt="MeriPustak-About"/>
                           
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-content">
                           
                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                               MeriPustak's mission is to prioritize customer satisfaction by providing a global marketplace that meets their diverse needs. With a focus on excellence, reliability, and accessibility, MeriPustak aims to deliver an unparalleled experience, connecting customers with the books they desire and fostering a love for reading worldwide.
                            </p>
                            <p className="mt-3 wow fadeInUp" data-wow-delay=".7s">
                                The MeriPustak aims to provide a wide range of books, new and 100% original books, from various segments. The focus is on offering 100% genuine books to customers. Additionally, MeriPustak emphasizes high-quality packaging to ensure that the books reach customers in excellent condition.
                            </p>
							<p className="mt-3 wow fadeInUp" data-wow-delay=".7s">
                                In addition to providing superior service to customers, MeriPustak strives to create an exceptional digital ambiance for users. This digital environment is designed to enhance the overall experience of browsing, purchasing, and interacting with the platform.
                            </p>
                           
                        </div>
                    </div>
                </div>
				<br/>
				<div className="row g-4 align-items-center">
                    
                    <div className="col-lg-6">
                        <div className="about-content">
                           
                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                               <b>Globally, the trafficking of counterfeit goods is much larger and growing. That growth is driven in part by CONSUMER DEMAND.</b> The best way to avoid purchasing counterfeit products is to deal only with reputable retailers that are officially authorized by the brand owner. Also keep in mind that if a price seems too good to be true, it probably is. Piracy and counterfeiting in books are not far behind. <b>Piracy is an important issue for publishers.</b>


                            </p>
                           
                        </div>
                    </div>
					<div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                        <div className="about-image">
                            <img src="assets/img/static-img/piracy.jpg" alt="MeriPustak-About"/>
                           
                        </div>
                    </div>
                </div>
				<br/>
				<div className="row g-4 align-items-center">
                    <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                        <div className="about-image">
                            <img src="assets/img/static-img/genuine.jpg" alt="MeriPustak-About"/>
                           
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-content">
                           
                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                              <b>All products sold on MeriPustak are new and 100% genuine products.</b>
                            </p>
                            <p className="mt-3 wow fadeInUp" data-wow-delay=".7s">
                                All books are procured directly from the publisher & authorized distributors, eliminating any middlemen and the possibility of procuring counterfeit books.

                            </p>
							<p className="mt-3 wow fadeInUp" data-wow-delay=".7s">
                                This can be verified and confirmed by the customer at any time. We have a systematic online procurement system and all orders are routed through it for our purchases from the publisher.

                            </p>
							<p className="mt-3 wow fadeInUp" data-wow-delay=".7s">
                               Furthermore, MeriPustak recognizes its role in contributing to the reading community it serves. By offering a diverse selection of books, the marketplace aims to cater to the interests and preferences of readers. This commitment to the reading community is part of the broader mission.

                            </p><p className="mt-3 wow fadeInUp" data-wow-delay=".7s">
                                Lastly, MeriPustak acknowledges the importance of its team members and their job satisfaction. The mission includes a focus on providing a supportive and fulfilling work environment for the employees who are instrumental in supporting the marketplace's mission.


                            </p><p className="mt-3 wow fadeInUp" data-wow-delay=".7s">
                                Overall, the mission of MeriPustak is to provide customers with genuine books, exceptional service, and a seamless digital experience, while also contributing to the reading community and ensuring job satisfaction for its team members.


                            </p>
							
                        </div>
                    </div>
                </div>
				<br/>
				<div className="row g-4 align-items-center">
                
                    <div className="col-lg-12">
                        <div className="about-content">
                           
                          
							<p className="mt-3 wow fadeInUp" data-wow-delay=".7s">
                              <b>Thank you for partnering with us on our mission to build a more ethical and sustainable social business. We recognize that the support and collaboration of our customers are essential to our work. That's why we are deeply committed to providing the best price, selection, customer service, and overall shopping experience. Together, we can make a positive impact and create a better future for all.</b>



                            </p>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

      {/* <!-- Team Section Start --> */}
    <section className="team-section fix section-padding pt-0 margin-bottom-30">
        <div className="container">
            <div className="section-title text-center">
                <h2 className="mb-3 wow fadeInUp" data-wow-delay=".3s">Team</h2>
            </div>
            <div className="array-button">
                <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                <button className="array-next"><i className="fal fa-arrow-right"></i></button>
            </div>
            <div className="swiper team-slider">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img1.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img2.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img3.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img4.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img5.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img6.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img7.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img8.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img9.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img10.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="team-box-items">
                            <div className="team-image">
                                <div className="thumb">
                                    <img src="assets/img/static-img/img11.jpg" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    </>);
}
export default AboutUs;